<template>
  <div class="hotZoneImg">
    <div>
      <div class="upload-box">
        <SpOnlyPicSelect
          :image-url="hotZoneImg.config.imgUrl"
          @selectImage="selectImageData"
        />
      </div>
      <div>热区标注：</div>
      <hotzone
        v-if="hotZoneImg.config.imgUrl"
        class="hotzone"
        :image="hotZoneImg.config.imgUrl"
        :zones-init="hotZoneImg.data"
        @add="handleAdd"
        @change="handleChange"
        @remove="handleRemove"
      />
      <div
        v-for="(item, index) in hotZoneImg.data"
        :key="index"
        class="setting-item slider"
      >
        <div class="setPathBox">
          <div>
            <i
              class="iconfont icon-link"
              @click="handleGoodsChange(index)"
            />设置区块{{
              index + 1
            }}路径
          </div>
          <el-select
            v-model="hotZoneImg.data[index].linkPage"
            :placeholder="`设置区块${index + 1}跳转路径`"
            @change="hotZoneImgDataChange"
          >
            <el-option
              v-for="opt in options"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
import hotzone from 'vue-hotzone'
export default {
  name: 'SpHotZoneImgCmp',
  components: {
    hotzone: hotzone
  },
  mixins: [mixin],
  data () {
    return {
      hotZoneImg: {
        config: {
          imgUrl: ''
        },
        data: []
      },
      options: [
        {
          value: 'form',
          label: '跳转表单'
        },
        {
          value: 'description',
          label: '活动说明弹窗'
        },
        {
          value: 'prize',
          label: '奖品弹窗'
        }
      ],
      value: ''
    }
  },
  watch: {},
  created () {},
  methods: {
    hotZoneImgDataChange (data, index) {
      console.log('hotZoneImgDataChange', data, index)
    },
    handleImgChange (index) {
      this.$emit('bindImgs', index)
    },
    handleGoodsChange (index) {
      this.$emit('bindLinks', index)
    },
    handleAdd () {
      let item = {
        linkPage: '',
        title: '',
        id: ''
      }
      this.hotZoneImg.data.push(item)
    },
    handleChange (zone) {
      setTimeout(() => {
        zone.forEach((item, index) => {
          if (item.leftPer) {
            let obj = {
              heightPer: item.heightPer,
              leftPer: item.leftPer,
              topPer: item.topPer,
              widthPer: item.widthPer
            }
            Object.assign(this.hotZoneImg.data[index], obj)
          }
        })
      }, 500)
    },
    selectImageData (selectdata) {
      let msg_type = 'image'
      if (msg_type === 'image') {
        this.hotZoneImg.config.imgUrl = selectdata
      } else if (msg_type === 'link') {
        this.content.link.picurl = selectdata
      } else if (msg_type === 'miniprogram') {
        this.content.miniprogram.img_url = selectdata
      }
    },
    handleRemove (index) {
      this.hotZoneImg.data.splice(index, 1)
    }
  }
}
</script>
<style scoped lang="scss">
.setPathBox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  line-height: 36px;
}
.margin_container {
  display: flex;
}
.margin_box {
  margin-right: 8px;
  text-align: center;
  .margin_box_text {
    margin-top: 4px;
  }
}

.upload-box {
  height: 100px;
  width: 100px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-bottom: 10px;
  img {
    width: 100%;
  }
}
.hotzone {
  max-width: 500px;
  margin-bottom: 10px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
}
.uploader-setting {
  padding: 0;
}
</style>
